import CircularProgress from '@mui/material/CircularProgress';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import { PdfElementsViewer } from './pdf-elements-viewer.js';

export const Route = createFileRoute('/_authorization-gate/file/$fileId/elements')({
	staticData: {
		authorize: (ability) => ability.can('manage', 'devTools'),
	},
	head: () => ({ meta: [{ title: 'PDF Elements • Cadstrom' }] }),
	component: PdfElementsViewerPage,
});

function PdfElementsViewerPage() {
	const { fileId } = Route.useParams();

	return (
		<div className='flex h-screen w-screen flex-col bg-gray-a2 p-4'>
			<Suspense
				fallback={
					<div className='grid h-full w-full place-items-center'>
						<CircularProgress />
					</div>
				}
			>
				<PdfElementsViewer fileId={fileId} />
			</Suspense>
		</div>
	);
}
